import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Scrollbars} from 'react-custom-scrollbars';
import {SpringSystem} from 'rebound';
// import './style.css';
// import {EVENT_ID, dispatch} from '../containers/event_manager';

export class CustomScrollDiv extends Component {
	componentDidMount() {
		this.props.setScrollbarsRef(this.scrollbars.container.firstChild);
		this.springSystem = new SpringSystem();
		this.spring = this.springSystem.createSpring();
		this.spring.setOvershootClampingEnabled(true);
		this.spring.addListener({onSpringUpdate: this.handleSpringUpdate.bind(this)});
	}

	componentWillUnmount() {
		this.springSystem.deregisterSpring(this.spring);
		this.springSystem.removeAllListeners();
		this.springSystem = undefined;
		this.spring.destroy();
		this.spring = undefined;
	}

	setScrollTop(top) {
		this.scrollbars.scrollTop(top);
	}

	animateScrollTop(top) {
		const scrollTop = this.scrollbars.getScrollTop();
		this.spring.setCurrentValue(scrollTop).setAtRest();
		this.spring.setEndValue(top);
	}

	scrollToLeft() {
		return this.scrollbars.scrollToLeft();
	}

	getScrollTop() {
		return this.scrollbars.getScrollTop();
	}

	getScrollHeight() {
		return this.scrollbars.getScrollHeight();
	}

	getHeight() {
		return this.scrollbars.getClientHeight();
	}

	handleSpringUpdate(spring) {
		const val = spring.getCurrentValue();
		this.scrollbars.scrollTop(val);
	}

	handleScrollStart() {
		this.props.onScrollStart();
	}

	handleScroll(e) {
		this.props.handleScroll(e);
	}

	render() {
		// eslint-disable-next-line no-unused-vars
		const {setScrollbarsRef, horizontalContent, handleScroll, scrollParent, ...rest} = this.props;
		delete rest.marginBottom;
		return (
			<Scrollbars
				ref={div => {
					this.scrollbars = div;
				}}
				onScroll={this.handleScroll.bind(this)}
				onScrollStart={this.handleScrollStart.bind(this)}
				className={
					'custom-scrollbar-div-remove ' +
					(this.props.horizontalandverticalcontent
						? 'view-horizontal-vertical'
						: horizontalContent
						? 'view-horizontal'
						: 'view-vertical')
				}
				hideTracksWhenNotNeeded={true}
				autoHide={this.props.autoHide !== undefined ? this.props.autoHide : true}
				style={{height: 'auto', marginBottom: this.props.marginBottom}}
				autoHeight={this.props.autoHeight ? this.props.autoHeight : false}
				autoHeightMin={this.props.autoHeightMin ? this.props.autoHeightMin : null}
				autoHeightMax={this.props.autoHeightMax ? this.props.autoHeightMax : null}
				renderTrackHorizontal={({style, props}) => {
					return (
						<div
							{...props}
							style={{
								...style,
								position: 'absolute',
								height: '6px',
								transition: 'opacity 200ms ease 0s',
								borderRadius: '3px',
								opacity: '0',
								right: '2px',
								bottom: '2px',
								left: '2px',
								visibility: 'hidden',
								zIndex: 5,
							}}
						/>
					);
				}}
				renderThumbHorizontal={({style, props}) => (
					<div
						{...props}
						style={{
							...style,
							position: 'relative',
							height: '100%',
							cursor: 'pointer',
							borderRadius: 'inherit',
							backgroundColor: 'rgba(0, 0, 0, 0.2)',
							display: 'block',
							width: '0px',
						}}
					/>
				)}
				renderTrackVertical={({style, props}) => (
					<div
						{...props}
						style={{
							...style,
							position: 'absolute',
							width: '6px',
							transition: 'opacity 200ms ease 0s',
							right: '2px',
							bottom: '2px',
							top: '2px',
							borderRadius: '3px',
							zIndex: 5,
						}}
					/>
				)}
				renderThumbVertical={({style, props}) => (
					<div
						{...props}
						style={{
							...style,
							width: '100%',
							cursor: 'pointer',
							borderRadius: 'inherit',
							backgroundColor: 'rgba(0, 0, 0, 0.2)',
						}}
					/>
				)}
				{...rest}
			/>
		);
	}
}

CustomScrollDiv.propTypes = {
	setScrollbarsRef: PropTypes.func,
	scrollParent: PropTypes.any,
	onScrollStart: PropTypes.func,
	handleScroll: PropTypes.func,
	scrollEventId: PropTypes.any,
	horizontalContent: PropTypes.any,
	horizontalandverticalcontent: PropTypes.any,
	autoHide: PropTypes.any,
	autoHeight: PropTypes.any,
	autoHeightMin: PropTypes.any,
	marginBottom: PropTypes.any,
	autoHeightMax: PropTypes.any,
};

CustomScrollDiv.defaultProps = {
	setScrollbarsRef: () => false,
	onScrollStart: () => false,
	handleScroll: () => false,
};
